<template>
    <div class="tr" :class="active ? 'bg-yellow-500' : ''" @click="highlightMe">
        <div class="td">
            <editable-cell-input :id="configuration.id"
                                 :data="note"
                                 :field="'nota'"
                                 :url="url"
                                 @data-has-changed="onDataHasChanged">
            </editable-cell-input>
        </div>
        <div class="td" style="flex-grow: 2">
            <editable-cell-selector :id="configuration.id"
                                    :data="configuration.string_type"
                                    :field="'string_type'"
                                    :item_type="'wires'"
                                    :url="url"
                                    @data-has-changed="onDataHasChanged"
            >

            </editable-cell-selector>
        </div>
        <div class="td" style="flex-grow: 2">
            <editable-cell-selector :id="configuration.id"
                                    :data="configuration.r_spina"
                                    :field="'r_spina'"
                                    :item_type="'spine'"
                                    :url="url"
                                    @data-has-changed="onDataHasChanged"
            >

            </editable-cell-selector>
        </div>
        <div class="td">
            <editable-cell-input :id="configuration.id"
                                 :data="configuration.h_spina"
                                 :field="'h_spina'"
                                 :url="url"
                                 @data-has-changed="onDataHasChanged">
            </editable-cell-input>
        </div>
        <div class="td" style="flex-grow: 2" v-if="isLever">
            <editable-cell-selector :id="configuration.id"
                                    :data="configuration.r_capotasto"
                                    :field="'r_capotasto'"
                                    :item_type="'capotasti'"
                                    :url="url"
                                    @data-has-changed="onDataHasChanged"
            >
            </editable-cell-selector>
        </div>
        <div class="td" v-if="isLever">
            <editable-cell-input :id="configuration.id"
                                 :data="configuration.h_capotasto"
                                 :field="'h_capotasto'"
                                 :url="url"
                                 @data-has-changed="onDataHasChanged">
            </editable-cell-input>
        </div>
        <div class="td" style="flex-grow: 2" v-if="isLever">
            <editable-cell-selector :id="configuration.id"
                                    :data="configuration.r_levetta"
                                    :field="'r_levetta'"
                                    :item_type="'levette'"
                                    :url="url"
                                    @data-has-changed="onDataHasChanged"
            >
            </editable-cell-selector>
        </div>
        <div class="td" style="flex-grow: 2">
            <editable-cell-selector :id="configuration.id"
                                    :data="configuration.r_boccola"
                                    :field="'r_boccola'"
                                    :item_type="'boccole'"
                                    :url="url"
                                    @data-has-changed="onDataHasChanged"
            >
            </editable-cell-selector>
        </div>
        <div class="td">
            {{ configuration.revisione }}
        </div>
    </div>
</template>


<script>
    import EditableCellInput from '../../EditableCellInput.vue';
    import EditableCellSelector from '../../EditableCellSelector.vue';

    export default {
        inject: ['stringsLayoutState'],

        components: {EditableCellInput, EditableCellSelector},

        props: ['dataset', 'revision', 'isLever'],

        data() {
            return {
                'configuration': this.dataset,
                'edited': this.dataset,
                'revisioned': false,
                'string_types': '',
                'url': '/api/single-string-layout/',
                'rowId': this.dataset.position
            }
        },

        computed: {
            note() {
                return this.configuration.nota.replace('/', '').trim();
            },

            active() {
                return this.rowId == this.stringsLayoutState.activeRow
            }
        },

        methods: {
            onDataHasChanged() {
                if (!this.revisioned) {
                    axios.patch(`/api/single-string-layout/${this.configuration.id}`, {'revisione': this.revision})
                        .then(() => {
                            this.configuration.revisione = this.revision;
                        })
                }
            },

            highlightMe() {
                this.stringsLayoutState.activeRow = this.rowId
            }
        }
    }
</script>